import { render, staticRenderFns } from "./SuppliersBookingSettings.vue?vue&type=template&id=fdf5f39a&"
import script from "./SuppliersBookingSettings.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports